import { useEffect, useState } from "react";
import {
  applyTheme,
  getStoredDarkMode,
  setStoredDarkMode,
  subscribeToThemeChange,
} from "../utils/theme";

export function useTheme() {
  const [darkMode, setDarkModeState] = useState(getStoredDarkMode);

  useEffect(() => {
    applyTheme(darkMode);
  }, [darkMode]);

  useEffect(() => subscribeToThemeChange(setDarkModeState), []);

  const setDarkMode = (nextDarkMode) => {
    setDarkModeState(nextDarkMode);
    setStoredDarkMode(nextDarkMode);
  };

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return {
    darkMode,
    setDarkMode,
    toggleDarkMode,
  };
}
